export default __webpack_public_path__ + "static/banner-travel-dream-vacation-c0640ca427b4c38e7acbc566985734ef.webp";